import { useDispatch } from 'react-redux';
import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { bulkUpdateExpense, getExpenseMyCommon } from '../../api/constlink';
import {} from '../../util/utils';
import ExpenseBulkEditComponent from '../../components/expenses/ExpenseBulkEditComponent';
import { getMyExpenseListAsync } from '../../modules/expenses';

interface ExpenseBulkEditDrawerProps {
  enterpriseId: string;
  selectedExpenses: number[] | null;
  onClose: () => void;
}

function ExpenseBulkEditDrawer({
  enterpriseId,
  selectedExpenses,
  onClose,
}: ExpenseBulkEditDrawerProps) {
  const [expenseCommon, setExpenseCommon] = useState<any>();

  useEffect(() => {
    if (selectedExpenses === null) return;
    (async () => {
      const expenseCommon = await getExpenseMyCommon(enterpriseId);
      setExpenseCommon({
        ...expenseCommon,
      });
    })();
  }, [enterpriseId, selectedExpenses]);

  const dispatch = useDispatch();

  const onUpdate = async (data: any) => {
    const _data: any = {
      category: data.category,
      projectId: data.project.id,
      idList: selectedExpenses,
    };
    if (data.gongjong) _data.gongjong = data.gongjong;
    if (data.description) _data.description = data.description;

    await bulkUpdateExpense({
      enterpriseId,
      data: {
        ..._data,
      },
    });

    dispatch(
      getMyExpenseListAsync.request({
        enterpriseId,
      }),
    );

    onClose();
  };

  return (
    <>
      {expenseCommon && (
        <Drawer
          width={600}
          placement="right"
          closable={false}
          onClose={onClose}
          open={selectedExpenses !== null}
        >
          {selectedExpenses && (
            <ExpenseBulkEditComponent
              onUpdate={onUpdate}
              onCancel={onClose}
              expenseCommon={expenseCommon}
              selectedExpenses={selectedExpenses}
            />
          )}
        </Drawer>
      )}
    </>
  );
}

export default ExpenseBulkEditDrawer;
